module.exports = __webpack_public_path__ + "img/11.92f5f715.jpg";